import React from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity, Linking } from 'react-native';
import { Colors } from '@/constants/colors';
import { LinkPreview } from '@/services/chat/chatService';

interface LinkPreviewCardProps {
  preview: LinkPreview;
}

export const LinkPreviewCard: React.FC<LinkPreviewCardProps> = ({ preview }) => {
  const open = () => {
    if (preview.url) Linking.openURL(preview.url).catch(() => {});
  };

  return (
    <TouchableOpacity style={styles.container} onPress={open} activeOpacity={0.85}>
      {preview.image_url ? (
        <Image source={{ uri: preview.image_url }} style={styles.image} resizeMode="cover" />
      ) : null}
      <View style={styles.body}>
        {preview.site_name ? (
          <Text style={styles.site} numberOfLines={1}>
            {preview.site_name}
          </Text>
        ) : null}
        <Text style={styles.title} numberOfLines={2}>
          {preview.title || preview.url}
        </Text>
        {preview.description ? (
          <Text style={styles.desc} numberOfLines={2}>
            {preview.description}
          </Text>
        ) : null}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: Colors.border.default,
    backgroundColor: Colors.background.tertiary,
    borderRadius: 10,
    overflow: 'hidden',
    marginTop: 8,
  },
  image: {
    width: '100%',
    height: 140,
    backgroundColor: Colors.background.secondary,
  },
  body: {
    padding: 10,
    gap: 4,
  },
  site: {
    fontSize: 11,
    color: Colors.text.tertiary,
  },
  title: {
    fontSize: 14,
    fontWeight: '700',
    color: Colors.text.primary,
  },
  desc: {
    fontSize: 12,
    color: Colors.text.secondary,
  },
});
